export const USER_PERMISSIONS = {
  /* GENERATOR_INJECT_DOMAIN */
  LIST_ALL_WORKING_PART: "LIST_ALL_WORKING_PART",
  LIST_MERMA: "LIST_MERMA",
  LIST_CODE: "LIST_CODE",
  LIST_SECTOR: "LIST_SECTOR",
  LIST_LOCATION: "LIST_LOCATION",
  LIST_ARTICLE: "LIST_ARTICLE",
  LIST_TASK: "LIST_TASK",
  LIST_BATCH: "LIST_BATCH",
  LIST_VARIETY: "LIST_VARIETY",
  LIST_VIVERO: "LIST_VIVERO",
  PART_VALIDATE: "PART_VALIDATE",
  CONFIRM_PART: "CONFIRM_PART",
  DELETE_PART: "DELETE_PART",
  INIT: "INIT",
  ADM_CREATE_PART: "ADM_CREATE_PART",
};
